<script>
export default {
    name: 'PublicationPolicy',
}
</script>
<template>
  <a
    href="https://www.clinicalgenome.org/docs/clingen-publication-policy-and-manuscript-concept-form/"
    target="publication-policy"
  >ClinGen publication policy</a>
</template>